const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api';

const apiConfig = {
  BASE_URL: API_BASE_URL,
  SERVICES: {
    GET_ALL: `/services`,
  },
  PROJECTS: {
    GET_ALL: `/projects`,
    GET_ONE: (slug) => `/projects/${slug}`,
  },
};
export default apiConfig;
